<div class="tr-alert">
  <div class="middle">
    <div class="alert alert-{{alert.type}} d-flex fade show tr-alert-box" *ngFor="let alert of alerts">
      <div class="flex-grow-1">
        <ng-container *ngIf="!alert.bodyTemplate">
          <span>
            <strong>{{ alert.heading }}</strong> {{alert.body}}
            <ng-container *ngIf="alert.actions?.length">
              <button *ngFor="let action of alert.actions" type="button"
                class="btn btn-link btn-sm p-0 text-{{alert.type}} ms-2" (click)="handleAction(action, alert.id)">
                {{ action.label }}
              </button>
            </ng-container>
          </span>
        </ng-container>

        <ng-container *ngIf="alert.bodyTemplate">
          <strong>{{ alert.heading }}</strong>
          <ng-container [ngTemplateOutlet]="alert.bodyTemplate"></ng-container>
          <ng-container *ngIf="alert.actions?.length">
            <button *ngFor="let action of alert.actions" type="button"
              class="btn btn-link btn-sm p-0 text-{{alert.type}} ms-2" (click)="handleAction(action, alert.id)">
              {{ action.label }}
            </button>
          </ng-container>
        </ng-container>
      </div>

      <button type="button" class="btn-close ms-3" (click)="close(alert.id)" aria-label="Close"></button>
    </div>
  </div>
</div>
